import PropTypes from 'prop-types';
import { HeroTitle, StyledBanner } from './StaticPageHero.style';

const StaticPageHero = ({ titleBanner }) => {
  return (
    <StyledBanner>
      <HeroTitle>{titleBanner}</HeroTitle>
    </StyledBanner>
  );
};

StaticPageHero.propTypes = {
  titleBanner: PropTypes.string.isRequired,
};

export default StaticPageHero;
